import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface DonorCounts {
  totalDonors: number;
  appointmentsToday: number;
  donationsThisMonth: number;
}

export const donorsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDonorCounts: builder.query<DonorCounts, void>({
      query: () => "/donors/counts",
      transformResponse: (res: ApiResponse<DonorCounts>) => res.data,
      providesTags: ["Donors"],
    }),
  }),
});

export const { useGetDonorCountsQuery } = donorsApi;
